import Select, { OptionsType } from 'react-select';
import sortStyles from 'theme/react-select/sort';

const OrderSelect = ({
  options,
  onChange,
  defaultValue = null,
  compact = false,
}: {
  options: OptionsType;
  onChange: (...args: any[]) => void;
  defaultValue: any;
  compact?: boolean;
}) => {
  return (
    <Select
      options={options}
      defaultValue={defaultValue}
      onChange={(value) => {
        onChange(value);
      }}
      styles={sortStyles(false, compact ? 40 : undefined)}
    />
  );
};

export default OrderSelect;
